import { render } from "./TableGridSetting.vue?vue&type=template&id=f065e8a6&scoped=true"
import script from "./TableGridSetting.vue?vue&type=script&lang=js"
export * from "./TableGridSetting.vue?vue&type=script&lang=js"

import "./TableGridSetting.vue?vue&type=style&index=0&id=f065e8a6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f065e8a6"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/TableGridSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f065e8a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f065e8a6', __exports__)) {
    api.reload('f065e8a6', __exports__)
  }
  
  module.hot.accept("./TableGridSetting.vue?vue&type=template&id=f065e8a6&scoped=true", () => {
    api.rerender('f065e8a6', render)
  })

}


export default __exports__